import { DrawerProps } from './drawer.types';

export const DrawerPresets: Partial<DrawerProps> = {
  open: false,
};
